import type { ShaderMaterial } from 'three';

import { INITIALIZED_SHARED_MATERIAL_UNIFORM } from './constant';
import type { ShaderMaterialUniform } from './type';

export const setMaterialUniform = (
  material: ShaderMaterial,
  uniformMap: Partial<ShaderMaterialUniform>,
) => {
  Object.entries(uniformMap).forEach(([k, v]) => {
    if (k === 'uNumActiveBoxList') {
      material.defines.MAX_BOX_LIST = Math.max(v as number, 1);
    }

    material.uniforms[k].value = v;
  });

  validifyShaderMaterialUniform(material, material.defines.MAX_BOX_LIST);

  material.needsUpdate = true;
};

export const validifyShaderMaterialUniform = (
  material: ShaderMaterial,
  length: number,
) => {
  for (const key in INITIALIZED_SHARED_MATERIAL_UNIFORM) {
    const uniform = material.uniforms[key];

    if (uniform.value.length < length) {
      const val =
        INITIALIZED_SHARED_MATERIAL_UNIFORM[
          key as keyof typeof INITIALIZED_SHARED_MATERIAL_UNIFORM
        ];

      uniform.value = Array.from({ length }, () => val);
    }
  }
};
